
import {of as observableOf, Observable} from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Config} from './config.model';
import {environment} from '../../environments/environment';

@Injectable()
export class ConfigService {

  public static URL_OAUTH = '/authentication/auth/oauth/token';

  public static USER_ROLES_URL = '/v1/ruolo/ruoliattivi/'

  public static API_BASE = '/api';

  public static ACE = '/ace-webapp';
  public static GEO = '/geo-webapp';
  public static SIPER = '/siper-webapp';

  private config: Config = null;

  constructor(private httpClient: HttpClient) {}

  public initializeConfiguration(): Observable<Config> {
    return observableOf(new Config(environment.zuul_uri));
  }

  getGateway(): Observable<string> {
    if (this.config) {
      return observableOf(this.config.gateway);
    }
    return this.initializeConfiguration().pipe(map(
      (config) => {
        return config.gateway;
      }
    ),catchError((error) => {
      console.error('La configurazione non è stata inizializzata');
      return observableOf(null);
    }),);

  }

  getApiBase(): Observable<string> {
    return this.getGateway().pipe(map( gateway => {
      return gateway + ConfigService.API_BASE;
    }));
  }

}
